<template>
<button
  class="btn"
  type="button"
  :disabled="disabled || isLoading"
  @click="onClick">
  <strong v-if="isLoading">Adicionando ao carrinho...</strong>
  <strong
    v-else
    :key="disabled">
    {{ disabled ? 'Selecione data, horário e quantidade de ingressos' : 'Reservar agora' }}
  </strong>
</button>
</template>

<script>

export default {
    name:'SubimtButtonEvento',
    props: {
        disabled: {
            type: Boolean,
            default: () => false,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: () => false,
            required: true
        }
    },
    emits: ['click'],
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.btn {
    width: 100%;
    text-align: center;
    border: 0px;
    background-color: #E88A1D;
    border-radius: 4px;
    padding: 15px;
    color: white;
    cursor: pointer;
}
.btn[disabled] {
    cursor: default;
    background-color: #464646;
    color:#D3D3D3;
}
</style>
